module.exports = "/images/Batting Cages.svg?297dffb12b29f60307440509747ed53e";